import {
    chakra, Flex, Button, Box
} from '@chakra-ui/react';

import { ModalWrapper } from '../../../../../components/modal-wrapper';

export const wrapper = chakra(ModalWrapper, {
    label: 'try-new-course-wrapper',
    baseStyle: {
        flexDirection: 'column',
        padding: 0,
        position: 'relative',
        border: '8px solid',
        borderColor: '#ccc',
        borderRadius: '20px'
    }
});

export const container = chakra(Flex, {
    label: 'try-new-course-container',
    baseStyle: {
        w: '832px',
        h: '454px',
        flexDirection: 'column',
        alignItems: 'center',
        padding: 0,
        overflow: 'hidden',
        mb: '0px !important',
        borderRadius: '20px'
    }
});

export const footer = chakra(Flex, {
    label: 'try-new-course-footer',
    baseStyle: {
        alignItems: 'center',
        justifyContent: 'flex-end',
        h: '72px',
        w: '100%',
        borderRadius: '0px 0px 10px 10px',
        mb: '0px !important',
        backgroundColor: '#fff'
    }
});

export const closeButton = chakra(Button, {
    label: 'try-new-course-close-button',
    baseStyle: {
        border: '1px solid',
        borderColor: 'neutral.400',
        borderRadius: '20px',
        w: '40px',
        h: '40px',
        backgroundColor: '#fff',
        position: 'absolute',
        top: '-15px',
        right: '-15px'
    }
});

export const buttonSecondary = chakra(Button, {
    label: 'try-new-course-button-secondary',
    baseStyle: {
        border: '1px solid',
        borderColor: 'primary.300',
        borderRadius: '40px',
        width: '176px',
        height: '48px',
        color: 'primary.600',
        fontSize: '20px',
        fontWeight: 500,
        backgroundColor: '#fff'
    }
});

export const buttonPrimary = chakra(buttonSecondary, {
    label: 'try-new-course-button-primary',
    baseStyle: {
        border: 'none',
        color: '#fff',
        background: 'linear-gradient(149deg, #00ABE8 4.33%, #007ACC 45.04%, #0063A7 100%)',
        _hover: { background: 'linear-gradient(149deg, #00ABE8 4.33%, #007ACC 45.04%, #0063A7 100%)' }
    }
});

export const heading = chakra(Box, {
    label: 'try-new-course-heading',
    baseStyle: {
        color: 'neutral.900',
        fontSize: '35px',
        lineHeight: '45.5px',
        letter: '-0.8px',
        fontWeight: 400
    }
});

export const subheading = chakra(heading, {
    label: 'try-new-course-subheading',
    baseStyle: { fontWeight: 700 }
});

